var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1211 15.6899V4.00781",
    stroke: "#00ABFB",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0371 12.8477L12.1211 15.6884L9.20511 12.8477",
    stroke: "#00ABFB",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7541 8.60156H17.6871C18.171 8.60156 18.6501 8.69404 19.0971 8.87372C19.5442 9.05341 19.9503 9.31677 20.2924 9.64876C20.6345 9.98076 20.9059 10.3749 21.091 10.8086C21.276 11.2424 21.3712 11.7073 21.3711 12.1767V16.9152C21.3711 17.8608 20.9839 18.7677 20.2947 19.4363C19.6055 20.105 18.6708 20.4806 17.6961 20.4806H6.55609C5.57877 20.4806 4.64148 20.1039 3.95041 19.4335C3.25933 18.763 2.87109 17.8536 2.87109 16.9055V12.1661C2.87136 11.2206 3.25866 10.314 3.94783 9.64552C4.637 8.97708 5.5716 8.60156 6.54609 8.60156H7.48809",
    stroke: "#00ABFB",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadImg);
export default __webpack_public_path__ + "static/media/downloadImg.07a739c406b9f12f68f4a1943c2201c9.svg";
export { ForwardRef as ReactComponent };